import "../scss/main.scss"

import Swup from "swup";
import SwupJsPlugin from '@swup/js-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupMorphPlugin from 'swup-morph-plugin';

import { customScrollPage, scrollHeader, handleScrollTarget } from "./scroll";
import { galleryComponentFunctions, newsSliderComponentFunctions } from "./sliders";
import { pageTransition } from "./utils";
import { Forms } from "./Forms";
import { ToastsFactory } from './ToastMessage';
import { FullLoader } from "./Loader";
import { ProductCard } from "./ProductCard";
import { SelettoreLingua } from "./SelettoreLingua";
//import { blobSplineShape, blobSplineShapeSmooth, circleWithEllipse, circleWithRectangle, helixWithStars, sinusCircle } from "./BgAnimations";
//import { MaterialScroller, MaterialSlider, productImageSlider } from "./sliders";
//import { MouseCursor } from "./Cursor";
//import { AccountPanel } from "./AccountPanel";
//import { MouseImageTrail } from "./MouseImageTrail";
//import { Mobile } from "./Mobile";
import { detectedDevice } from 'detected-device';
import Header from './Header';
import { Cart } from './Cart';
import { Tickets } from './Tickets';
import { VideoPlayer } from './VideoPlayer';

let scrollInstance = null;
let swupInstance   = null;
let loaderClass    = null;
let toastInstance   = null;
let mouseCursorInstance   = null;
let accountPanel   = null;
let classMobile = null;
let headerClass = null;
let cartClass = null;
let ticketsClass = null;

const formRegistry = new WeakMap();
const productCardRegistry = new WeakMap();
const selettoreLinguaRegistry = new WeakMap();
const videoPlayerRegistry = new WeakMap();

const initOnce = (el, initializer) => {
    if (!el || el.dataset.initialized === "1") return;
    initializer(el);
    el.dataset.initialized = "1";
}

const initComponents = (root = document) => {
    if(root.querySelectorAll('.gallery--component').length > 0) {
        root.querySelectorAll('.gallery--component').forEach(el => {
            galleryComponentFunctions(el.querySelector('.swiper'));
        });
    }
    if(root.querySelectorAll('.news-slider--component').length > 0) {
        root.querySelectorAll('.news-slider--component').forEach(el => {
            newsSliderComponentFunctions(el.querySelector('.swiper'));
        });
    }

    root.querySelectorAll(".form--component").forEach(el =>
        initOnce(el, el => {
        const instance = new Forms(el);
        formRegistry.set(el, instance);
        })

        /**
        PER RECUPERARE L'ISTANZA DEL FORM IN SEGUITO:
        const el = document.querySelector(".form--component");
        const formInstance = formRegistry.get(el);
        formInstance?.validate?.();
        */
    );
  
    root.querySelectorAll(".product-card--component").forEach(el =>
        initOnce(el, el => {
            if(!el.classList.contains('product-card--not-default')) {
                const instance = new ProductCard(el);
                productCardRegistry.set(el, instance);
            }
        })
    );

    root.querySelectorAll(".selettore-lingua").forEach(el =>
        initOnce(el, el => {
            const instance = new SelettoreLingua(el);
            selettoreLinguaRegistry.set(el, instance);
        })
    );

    root.querySelectorAll(".video--container").forEach(el =>
        initOnce(el, el => {
            const instance = new VideoPlayer(el);
            videoPlayerRegistry.set(el, instance);
        })
    );
}

const beforePageLeave = () => {
    if (scrollInstance && scrollInstance.stop) scrollInstance.stop();
    return pageTransition("enter");
}

const afterPageEnter = () => {
    if (scrollInstance && scrollInstance.start) scrollInstance.start();
    return pageTransition("exit");
}

const initSwup = () => {
  // Nota: con Swup l’ordine è: OUT (prima del replace) -> IN (dopo il replace).
    const transitions = [{
        from: "(.*)",
        to: "(.*)",
        out: async (next) => {           // PRIMA della sostituzione contenuti
            await beforePageLeave();
            next();
        },
        in: async (next) => {            // DOPO la sostituzione contenuti
            await afterPageEnter();
            next();
        }
    }];

    const options = {
        plugins: [
            new SwupJsPlugin(transitions),
            new SwupPreloadPlugin(),
            new SwupBodyClassPlugin(),
            new SwupMorphPlugin({ containers: ["header"] })
        ],
        containers: ["#swup"],
        animateHistoryBrowsing: true
    };

    swupInstance = new Swup(options);

    swupInstance.hooks.on("content:replace", () => {
        initComponents(document);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    // Istanziazioni “one-time”
    scrollInstance = customScrollPage();
    toastInstance = new ToastsFactory();
    loaderClass = new FullLoader();
    headerClass = new Header();
    cartClass = new Cart();
    ticketsClass = new Tickets();
    //mouseCursorInstance = new MouseCursor();
    //mouseCursorInstance.initAll();
    //accountPanel = new AccountPanel();
    //classMobile = new Mobile();

    scrollHeader();
    handleScrollTarget();
    //informationsPanel();
    //new Animations();
    //new StartingElementAnimation();

    initComponents(document);

    initSwup();

    window.dataLayer = window.dataLayer || [];

    // referrer iniziale = quello reale; poi diventa l'URL interno precedente
    let previousUrl = document.referrer;

    swupInstance.hooks.on('page:view', () => {
        window.dataLayer.push({
            event: 'swup_page_view',
            page_location: window.location.href,
            page_title: document.title,
            page_referrer: previousUrl,
        });
        previousUrl = window.location.href;
    })

    swupInstance.hooks.on('content:replace', () => {
        handleScrollTarget();
    }, { before: false });

});

export { scrollInstance, swupInstance, loaderClass, toastInstance, headerClass, cartClass, ticketsClass/* , mouseCursorInstance, accountPanel, classMobile */ };